import React, { useState } from "react";
import BackHomeButton from "../components/BackHomeButton";
import { db, auth } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { trackClick } from "./trackClick";
import { useLocation } from 'react-router-dom'; // Add this import

const ReferFriend = () => {

  const location = useLocation();
  const creatorData = location.state || {}; // Capture the passed creator info

  const [form, setForm] = useState({
    name: "",
    email: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleShare = async () => {
    if (!form.name || !form.email) {
      alert("Please fill name and email");
      return;
    }

    try {
      const user = auth.currentUser;

// Log the full "Who, Whom, and To Whom" relationship
      await addDoc(collection(db, "Referrals"), {
        // 1. THE REFERRER (Who)
        referredByUid: user?.uid || null,
        referredByEmail: user?.email || null,

        // 2. THE FRIEND (Whom)
        referredName: form.name,
        referredEmail: form.email,

        // 3. THE CREATOR (To Whom) - Only if coming from a Profile
        targetCreatorId: creatorData.targetCreatorId || "General_App_Share",
        targetCreatorName: creatorData.targetCreatorName || "Eascode",
        
        status: "pending",
        createdAt: serverTimestamp()
      });

      // Update the Share URL to include the Creator's profile if applicable
      const shareUrl = creatorData.targetCreatorId 
        ? `${window.location.origin}/CreatorProfile/${creatorData.targetCreatorId}`
        : window.location.origin;

      // 🔹 Share logic
const shareData = {
        title: "Join Eascode App",
        text: creatorData.targetCreatorName 
          ? `Check out ${creatorData.targetCreatorName}'s teaching resources on Eascode!`
          : "The AI powered Parent tool for collaborating and sharing worksheets.",
        url: shareUrl
      };

      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(shareData.url);
        alert("Link copied to clipboard");
      }
    } catch (error) {
      console.error("Referral failed:", error);
    }
  };

  return (
    <div style={styles.container}>
      <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "2rem" }}>
        <BackHomeButton />
      </div>

      <h2 style={styles.title}>🎁 Refer a Friend</h2>
      <p style={styles.subtitle}>
        Share with 10 friends & get a reward once they make their profile!
      </p>

      <input
        style={styles.input}
        type="text"
        name="name"
        placeholder="👤 Friend's Name"
        value={form.name}
        onChange={handleChange}
      />

      <input
        style={styles.input}
        type="email"
        name="email"
        placeholder="📧 Friend's Email"
        value={form.email}
        onChange={handleChange}
      />

      <button style={styles.button}  
       onClick={() => {
        trackClick("Refer Share Submitted");
        handleShare();
       }}
      >
        🚀 Share & Refer
      </button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "360px",
    margin: "40px auto",
    padding: "20px",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    textAlign: "center",
    fontFamily: "sans-serif",
    background: "#fff"
  },
  title: { marginBottom: "5px" },
  subtitle: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "20px"
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "12px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    fontSize: "14px",
    boxSizing: "border-box"
  },
  button: {
    width: "100%",
    padding: "14px",
    borderRadius: "12px",
    border: "none",
    background: "#4CAF50",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer"
  }
};

export default ReferFriend;
